import styled from 'styled-components'

export const Title = styled.h4`
  margin: 0;
  font-weight: var(--bq-font-weight--bold);
  color: var(--bq-endava-grey-800);
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  padding: var(--bq-spacing-xl) 0px var(--bq-spacing-m);
  @media screen and (max-width: 1395px) {
    padding: var(--bq-spacing-xs) 0;
  }
`
